export const userProfileTitleCss = {
  h2: {
    marginTop: 0,
  },
};

export const classContainerCss = {
  maxWidth: 1300,
};

export const classSectionTitleCss = {
  h2: {
    marginBottom: 0,
  },
};

export const preferenceContainerCss = {
  maxWidth: 900,
};

export const schoolContainerCss = {
  display: "flex",
  flexDirection: "row",
  gap: "30px",
};
